import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthService, ConnectionLostError} from "@customcoding/shared";

@Injectable()
export class ScapErrorInterceptor implements HttpInterceptor {

	ignoredUrls: string[] = [
		'/verify',
		'http://localhost:5000/api/status',
		'http://localhost:5001/api/status',
		'http://192.168.210.19:5000/api/status',
		'http://192.168.210.19:5001/api/status'
	]
	constructor(private authenticationService: AuthService, private router: Router) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError(err => {

			if (err.status === 401 && !this.ignoredUrls.includes(request.url)) {
				// Unauthorized
				this.authenticationService.logout();
			} else if (err.status === 403 && !this.ignoredUrls.includes(request.url)) {
				// Forbidden
				this.router.navigate(['/error/403'], {replaceUrl: true}).then();
			}
			else if (
				err.status === 0
				&& err.error
				&& err.error instanceof ProgressEvent
				&& err.url.includes("/api/api/")) {
				// Connection Problem (e.g. VPN lost)
				this.router.navigate(['/error/connection-lost']).then();
				return throwError(new ConnectionLostError('Connection Lost to Server (caught by ErrorInterceptor)', err));
			}

			return throwError(err);
		}));
	}
}

